import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          用户心声
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-950 truncate">
                    {item.name}
                  </div>
                  <div className="text-[11px] text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-foreground-400">
                <i className="ri-thumb-up-line text-xs"></i>
                <span className="text-xs">{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}